/**
 * Rows in the order they were in, after an edit made in place.
 *
 * Editing a task's due date from its row refetched the list and re-sorted it by
 * the new date, so the row jumped down the page (or onto another one) as the
 * user watched; nobody asked for a re-sort (z8nrz7fkgd follow-up). The order is
 * taken when the edit begins and held until the user changes what the list
 * shows. Rows it does not know (new since) follow, in their natural order; rows
 * gone since are simply absent.
 */
export function keepRowOrder<T>(
  rows: readonly T[],
  order: readonly string[] | null,
  keyOf: (row: T) => string = row => (row as { id: string }).id,
): T[] {
  if (!order) return [...rows]
  const at = new Map(order.map((key, i) => [key, i]))
  const known = rows
    .filter(r => at.has(keyOf(r)))
    .sort((a, b) => (at.get(keyOf(a)) as number) - (at.get(keyOf(b)) as number))
  return [...known, ...rows.filter(r => !at.has(keyOf(r)))]
}
